//TODO Change this to dynamic imports
import { ComcastPlatform } from './Comcast'
import { TizenPlatform } from './Tizen'
import { VizioPlatform } from './Vizio'
import WebOSPlatform from './WebOS'
import BasePlatform from './Platform'

export const PLATFORMS = {
  COMCAST: 'Comcast',
  VIZIO: 'Vizio',
  SAMSUNG: 'Samsung',
  XUMO: 'Xumo',
  LG: 'LG TV',
  BROWSER: 'Browser',
}

let Platform

if (COMPILING_FOR_COMCASTX1) {
  Platform = new ComcastPlatform()
} else if (COMPILING_FOR_VIZIO) {
  Platform = new VizioPlatform()
} else if (COMPILING_FOR_TIZEN) {
  Platform = new TizenPlatform()
} else if (COMPILING_FOR_LGTV) {
  Platform = new WebOSPlatform()
} else {
  Platform = new BasePlatform() // Default platform to be used on browsers
}

export default Platform
